import React, { useState, useEffect } from "react";
import GitHubCalendar from "react-github-calendar";
import { Row } from "react-bootstrap";

function Github() {
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    setRefreshKey(prev => prev + 1);
  }, []);

  // Auto-calculate Dec to Dec
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth();
  
  // If before December, show previous Dec to current Dec
  let startYear = currentYear - 1;
  let endYear = currentYear;
  
  if (currentMonth >= 11) { // If December or later
    startYear = currentYear;
    endYear = currentYear + 1;
  }
  
  const startDate = new Date(startYear, 11, 1);
  const endDate = new Date(endYear, 11, 31);

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
      <h1 className="project-heading" style={{ paddingBottom: "20px" }}>
        Days I <strong className="purple">Code</strong>
      </h1>
      <GitHubCalendar
        key={refreshKey}
        username="tandukarunique"
        blockSize={15}
        blockMargin={5}
        color="#c084f5"
        fontSize={16}
        transformData={(data) => {
          const start = startDate.getTime();
          const end = endDate.getTime();
          return data.filter(day => {
            const dayDate = new Date(day.date).getTime();
            return dayDate >= start && dayDate <= end;
          });
        }}
      />
    </Row>
  );
}

export default Github;